import _slicedToArray from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack } from '../../utils/index.js';
var floor = Math.floor;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */
var hcg2rgb = function hcg2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'hcg');
  var _args = args,
    _args2 = _slicedToArray(_args, 3),
    h = _args2[0],
    c = _args2[1],
    _g = _args2[2];
  var r, g, b;
  _g = _g * 255;
  var _c = c * 255;
  if (c === 0) {
    r = g = b = _g;
  } else {
    if (h === 360) h = 0;
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 60;
    var i = floor(h);
    var f = h - i;
    var p = _g * (1 - c);
    var q = p + _c * (1 - f);
    var t = p + _c * f;
    var v = p + _c;
    switch (i) {
      case 0:
        r = v;
        g = t;
        b = p;
        break;
      case 1:
        r = q;
        g = v;
        b = p;
        break;
      case 2:
        r = p;
        g = v;
        b = t;
        break;
      case 3:
        r = p;
        g = q;
        b = v;
        break;
      case 4:
        r = t;
        g = p;
        b = v;
        break;
      case 5:
        r = v;
        g = p;
        b = q;
        break;
    }
  }
  return [r, g, b, args.length > 3 ? args[3] : 1];
};
export default hcg2rgb;